import i18n from '../R/string/i18n';
import { FieldType } from '../presenters/me/userProfileHooks';
import { Nullable } from './type';

export const getProfileFieldTitle = (fieldType: Nullable<FieldType>) => {
  if (!fieldType) return;
  switch (fieldType) {
    case FieldType.NAME:
      return i18n.userNameEditFormTitle();
    case FieldType.PASSWORD:
      return i18n.resetPasswordTitle();
    case FieldType.LOCATION:
      return i18n.locationEdit();
    case FieldType.NICKNAME:
      return i18n.nicknameEditFormTitle();
  }
};
